var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('component-page', {
    attrs: {
      "title": "Breadcrumbs"
    },
    scopedSlots: _vm._u([{
      key: "basicUsage",
      fn: function fn() {
        return [_c('a-breadcrumbs', {
          attrs: {
            "items": _vm.commonBreadcrumbs
          }
        })];
      },
      proxy: true
    }])
  }, [_c('component-usage-example', {
    attrs: {
      "caption": "Custom text divider"
    }
  }, [_c('a-breadcrumbs', {
    attrs: {
      "items": _vm.commonBreadcrumbs,
      "divider": "·"
    }
  })], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Custom icon divider"
    }
  }, [_c('a-breadcrumbs', {
    attrs: {
      "items": _vm.commonBreadcrumbs
    },
    scopedSlots: _vm._u([{
      key: "divider",
      fn: function fn() {
        return [_c('chevron-double-right-icon')];
      },
      proxy: true
    }])
  })], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Native anchor tag support"
    }
  }, [_c('a-breadcrumbs', {
    attrs: {
      "items": [{
        text: 'Repository',
        href: 'https://github.com/bcastlel/vue-ui-kit'
      }, {
        text: 'Home',
        to: {
          name: 'home'
        }
      }, {
        text: 'Breadcrumbs',
        to: {
          name: 'breadcrumbs'
        }
      }]
    }
  })], 1), _c('component-usage-example', {
    attrs: {
      "caption": "Plain text support"
    }
  }, [_c('a-breadcrumbs', {
    attrs: {
      "items": [{
        text: 'App'
      }, {
        text: 'Home',
        to: {
          name: 'home'
        }
      }, {
        text: 'Breadcrumbs',
        to: {
          name: 'breadcrumbs'
        }
      }]
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }